import { styled } from 'styled-components';

import { media } from '@/utils/mediaQueries';

interface CoverProps {
    background?: string;
    height?: string;
}
type iconTypeProps ='square' | 'rectangle'
interface IconProps {
    type?: iconTypeProps;
}

export const EditBox = styled.div`
    position: absolute;
    top: 15px;
    right: -60px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 2;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.card.background};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};

    /* Dotyk (brak hover): akcje zawsze widoczne. */
    ${media.touch} {
        right: 15px;
        opacity: 1;
        pointer-events: auto;
    }
`;

export const DeleteBox = styled.div`
    position: absolute;
    top: 35px;
    right: -60px;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 1;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.danger[500]};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};

    /* Dotyk (brak hover): akcje zawsze widoczne. */
    ${media.touch} {
        top: 55px;
        right: 15px;
        opacity: 1;
        pointer-events: auto;
    }
`;

export const EventCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    &:hover ${EditBox} {
        right: 15px;
        top: 15px;
        bottom: auto;
        opacity: 1;
        pointer-events: auto;
        transform: translate(0%, 0%);
    }
    &:hover ${DeleteBox} {
        right: 15px;
        top:55px;
        bottom: auto;
        opacity: 1;
        pointer-events: auto;
        transform: translate(0%, 0%);
    }
`;

export const Cover = styled.div<CoverProps>`
    width: 100%;
    height: ${(props) => props.height || '200px'};
    overflow: hidden;
    position: relative;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-image: url(${(props) => props.background});
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    background-color: ${({ theme, background }) => !background ? (theme.mode === 'dark' ? '#374151' : '#e5e7eb') : 'transparent'};
`;

export const EmptyCoverIcon = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme }) => theme.mode === 'dark' ? '#6b7280' : '#9ca3af'};
    opacity: 0.5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
`;

export const EventCardBox = styled.div`
    width: 100%;
    height: auto;
    background: ${({ theme }) => theme.colors.card.background};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
    padding:  10px 15px;
    position:relative;
`;

export const ActionButtonsWrapper = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 6px;
`;

export const CardActionButton = styled.button<{ $variant?: 'default' | 'danger' }>`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    border: none;
    transition: all 0.2s ease-in-out;
    opacity: 0.85;

    svg {
        color: ${({ theme, $variant }) => ($variant === 'danger'
    ? theme.colors.danger[500]
    : theme.colors.text.secondary)};
    }

    &:hover {
        opacity: 1;
        background: ${({ theme, $variant }) => {
    if ($variant === 'danger') {
      return theme.mode === 'dark' ? 'rgba(239, 68, 68, 0.2)' : '#fef2f2';
    }
    return theme.mode === 'dark' ? '#374151' : '#f3f4f6';
  }};
        transform: translateY(-1px);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export const Title = styled.h3`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1.7;
`;

export const Subtitle = styled.p`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.primary};
    margin:0!important;
`;

export const Description = styled.p`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Time = styled.div`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
`;
export const IconWrapper = styled.div<IconProps>`
    width: auto;
    padding: 5px 10px;
    height: 35px;
    position: absolute;
    bottom: 15px;
    left: 10px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: rgba(0, 0, 0, 0.8);
    border:1px solid  rgba(255, 255, 255, 0.7);
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(225, 229, 238, 0.1) 0 2px 6px')};
    display: flex;
    font-size: 12px;
    align-items: center;
    font-weight: bold;
    color: #fff;
    justify-content: center;
`;

export const LocalizationWrapper = styled.div<IconProps>`
    width: auto;
    padding: 5px 8px;
    font-size: 12px;
    height: 35px;
    position: absolute;
    bottom:15px;
    right: 10px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: rgba(0, 0, 0, 0.9);
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(225, 229, 238, 0.1) 0 2px 6px')};
    border:1px solid  rgba(255, 255, 255, 0.9);
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: center;
    gap: 10px;
`;

export const StatusWrapper = styled.div`
    position: absolute;
    top: 15px;
    left: 10px;
`;
